'use client';

import cx from 'classix';
import Link from 'next/link';
import { useTranslations } from 'next-intl';
import {
  FaFacebookF,
  FaInstagram,
  FaPinterestP,
} from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { TfiYoutube } from 'react-icons/tfi';

import { getUserBearerCookie } from '@/features/user/cookies/cookie-user-bearer';
import {
  EXTERNAL_LINKS,
  ROUTER_LINKS,
  SOCIAL_MEDIA_LINKS,
} from '@/shared/constants/links-constants';

import styles from './footer.module.scss';

export default function Footer() {
  const linksTranslations = useTranslations('global.links');

  const loggedUser = getUserBearerCookie();
  const legalTranslations = useTranslations('global.legal');

  return (
    <div className={cx(styles.footer, loggedUser && styles.footer__isUserLogged)}>
      <div className={styles.mediaLinks}>
        <Link className={styles.footerLink} prefetch={false} href={SOCIAL_MEDIA_LINKS.facebook} target="_blank" rel="noopener noreferrer" aria-label="FacebookIcon"><FaFacebookF /></Link>
        <Link className={styles.footerLink} prefetch={false} href={SOCIAL_MEDIA_LINKS.twitter} target="_blank" rel="noopener noreferrer" aria-label="TwitterIcon"><FaXTwitter /></Link>
        <Link className={styles.footerLink} prefetch={false} href={SOCIAL_MEDIA_LINKS.youtube} target="_blank" rel="noopener noreferrer" aria-label="YoutubeIcon"><TfiYoutube /></Link>
        <Link className={styles.footerLink} prefetch={false} href={SOCIAL_MEDIA_LINKS.pinterest} target="_blank" rel="noopener noreferrer" aria-label="PinterestIcon"><FaPinterestP /></Link>
        <Link className={styles.footerLink} prefetch={false} href={SOCIAL_MEDIA_LINKS.instagram} target="_blank" rel="noopener noreferrer" aria-label="InstagramIcon"><FaInstagram /></Link>
      </div>
      <div className={styles.links}>
        {!loggedUser && (
          <Link
            // prefetch disabled, because this link protected by nginx
            // and when this link prefetch it also ask on current page for auth
            prefetch={false}
            className={styles.footerLink}
            href={ROUTER_LINKS.partner}
          >
            {linksTranslations('partner')}
          </Link>
        )}

        <Link className={styles.footerLink} href={EXTERNAL_LINKS.faq} target="_blank">{linksTranslations('faq')}</Link>

        <Link className={styles.footerLink} href={ROUTER_LINKS.terms}>{linksTranslations('terms')}</Link>

        <Link className={styles.footerLink} href={ROUTER_LINKS.privacy}>{linksTranslations('privacy')}</Link>

        { /* TODO: remove prefetch={false} when routes will be implemented in this app  */ }
        <Link className={styles.footerLink} href={ROUTER_LINKS.press}>{linksTranslations('press')}</Link>

        <Link className={styles.footerLink} href={EXTERNAL_LINKS.affiliateProgram} target="_blank">{linksTranslations('affiliate-program')}</Link>
        <Link className={styles.footerLink} href={EXTERNAL_LINKS.fairHousing} target="_blank">{linksTranslations('fair-housing')}</Link>

        { /* TODO: remove prefetch={false} when routes will be implemented in this app  */ }
        <Link className={styles.footerLink} prefetch={false} href={ROUTER_LINKS.blog} target="_blank">{linksTranslations('blog')}</Link>

        <Link className={styles.footerLink} href={ROUTER_LINKS.downloadApp}>{linksTranslations('download-app')}</Link>

        <Link className={styles.footerLink} href={ROUTER_LINKS.findingRoom}>{linksTranslations('finding-a-room')}</Link>

        <Link className={styles.footerLink} href={ROUTER_LINKS.rentingOutRoom}>{linksTranslations('renting-out-a-room')}</Link>
      </div>

      <div className={styles.links}>
        <button
          className={styles.infoShare}
          onClick={(event) => {
            event.preventDefault();

            // @ts-expect-error - lib cookiesyes included as script
            if (window.revisitCkyConsent) {
              // @ts-expect-error - lib cookiesyes included as script
              // eslint-disable-next-line @typescript-eslint/no-unsafe-call
              window.revisitCkyConsent();
            }
          }}
        >
          {legalTranslations('do-not-share-personal-information')}
        </button>
      </div>

      <div className={styles.copyRight}>
        Roomster &copy;
        {' '}
        {new Date().getFullYear()}
      </div>
    </div>
  );
}
